/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import {
    call,
    put,
    select,
    takeEvery,
    takeLatest,
    all,
} from 'redux-saga/effects';
import { actions } from '../../utils/constants';
import {
    createCourse,
    deleteCourse,
    fetchCourse,
    fetchCourses,
    updateCourse,
    withRetry,
    fetchTestTypes,
    fetchTemplateTests,
    updateCoursesTemplateTests,
    fetchCoursesTemplateTests,
} from '../../utils/common-functions';

function* fetchAllCourses() {
    yield put({
        type: actions.COURSES_FETCH_LOADING,
        payload: { loading: true },
    });
    try {
        const courses = yield call(withRetry(fetchCourses));
        yield put({ type: actions.COURSES_FETCHED, payload: courses.data });
    } catch (e) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message:
                    'Os cursos não puderam ser carregados. Tente recarregar a página',
            },
        });
    }
    yield put({
        type: actions.COURSES_FETCH_LOADING,
        payload: { loading: false },
    });
}

function* fetchOneCourse({ payload }) {
    try {
        const response = yield call(withRetry(fetchCourse), payload);
        yield put({ type: actions.COURSE_FETCHED, payload: response.data });
    } catch (e) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message:
                    'O curso não pôde ser carregado. Tente recarregar a página',
            },
        });
    }
}

export function* updateCourses() {
    const changedCourses = yield select(({ App }) => App.changedCourses);
    const courses = yield select(({ courses }) => courses.data);
    try {
        for (const changedCourseId of changedCourses) {
            const changedCourse = courses.find(
                c => c.courseId === changedCourseId,
            );
            if (changedCourse) {
                const {
                    typeTestsValues,
                    ...valuesToUpdateCourse
                } = changedCourse;

                yield call(
                    updateCourse,
                    changedCourse.courseId,
                    valuesToUpdateCourse,
                );
                if (typeTestsValues) {
                    yield call(updateCoursesTemplateTests, {
                        courseId: valuesToUpdateCourse.courseId,
                        data: typeTestsValues,
                    });
                }
            }
        }
    } catch (err) {
        if (
            err.response &&
            err.response.data.error_description ===
                'Teste deve ter status diferente de Incompleto'
        ) {
            yield put({
                type: actions.REQUEST_ERROR,
                payload: {
                    message:
                        'O teste está incompleto e não pode ser selecionado para o curso',
                },
            });
        } else {
            yield put({
                type: actions.REQUEST_ERROR,
                payload: {
                    message:
                        'As alterações não puderam ser salvas. Tente novamente',
                },
            });
        }

        throw err;
    }
}

function* fetchCoursesCreateTestsTypes({payload}){
    try {
        const { data } = yield fetchCoursesTemplateTests({
            courseId: payload,
        });
        yield put({ payload: data, type: actions.SET_SELECT_TESTS_CREATE_COURSE })
    }catch(err){
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message:
                    'Tente novamente',
            },
        });
    }
}

function* addCourse({ payload: { typeTestsValues, ...course } }) {
    try {
        const submit = course.submitCourse  ? { ...course.submitCourse } : undefined;
        delete course.submitCourse;
        let newCards = []
        if(submit){
            const { data } = yield call(withRetry(fetchCourse), submit.id);
            newCards = data.cards
        }
        yield createCourse({...course, cards: newCards});
        yield updateCoursesTemplateTests({
            courseId: course.courseId,
            data: typeTestsValues,
        });
        yield put({ type: actions.COURSE_CREATED, payload: course });
        yield put({ type: actions.ASYNC_FETCH_COURSES });
    } catch (err) {
        if (
            err.response &&
            err.response.data.error_description ===
                'Teste deve ter status diferente de Incompleto'
        ) {
            yield put({
                type: actions.REQUEST_ERROR,
                payload: {
                    message:
                        'O teste está incompleto e não pode ser selecionado para o curso',
                },
            });
        } else {
            yield put({
                type: actions.REQUEST_ERROR,
                payload: {
                    message:
                        'A criação da turma não pode ser salvas. Tente novamente',
                },
            });
        }
    }
}

function* removeCourse({ payload }) {
    try {
        yield deleteCourse(payload.courseId);
        yield put({ type: actions.COURSE_DELETED, payload });
    } catch (e) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message:
                    'As alterações não puderam ser salvas. Tente novamente',
            },
        });
    }
}

// eslint-disable-next-line require-yield
function* fecthTypeTests() {
    try {
        const response = yield call(fetchTestTypes);

        const testTypes = response.data.test_types;
        yield put({
            type: actions.FETCH_TYPE_TESTS,
            payload: testTypes,
        });
        const testTypesIds = testTypes.map(test => test.id);
        yield put({
            type: actions.ASYNC_FETCH_TESTS_BY_TYPE,
            payload: { testTypesIds },
        });
    } catch (e) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message:
                    'Não foi possível realizar a busca por tipos de testes. Tente novamente',
            },
        });
    }
}

// eslint-disable-next-line require-yield
function* fetchTestsByType({ payload: { testTypesIds } }) {
    try {
        const response = yield all(
            testTypesIds.map(typeTest =>
                call(fetchTemplateTests, { params: { test_type: typeTest } }),
            ),
        );

        const testsByType = {};
        testTypesIds.map((typeTest, index) => {
            testsByType[typeTest] = response[index].data.template_tests;
        });

        yield put({
            type: actions.FETCH_TESTS_BY_TYPE,
            payload: testsByType,
        });
    } catch (e) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message:
                    'Não foi possível realizar a listagem de testes. Tente novamente',
            },
        });
    }
}

// eslint-disable-next-line require-yield
function* fetchTestByCourse({ payload }) {
    try {
        yield put({ type: actions.FETCH_TESTS_BY_COURSE, payload: {} });
    } catch (e) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message:
                    'Não foi possível realizar a listagem das configurações de testes para o curso. Tente novamente',
            },
        });
    }
}

function* asyncFetchCourseTemplateTests({ payload: { courseId } }) {
    try {
        const response = yield fetchCoursesTemplateTests({
            courseId: courseId,
        });
        yield put({
            type: actions.CHANGE_COURSE_TEMPLATE_TESTS,
            payload: response.data,
        });
    } catch (e) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message: 'Não foi possível realizar os testes do curso.',
            },
        });
    }
}

export default function* courses() {
    yield takeLatest(actions.ASYNC_FETCH_ADMIN_DATA, fetchAllCourses);
    yield takeLatest(actions.ASYNC_FETCH_COURSES, fetchAllCourses);
    yield takeLatest(actions.ASYNC_FETCH_COURSE, fetchOneCourse);
    yield takeEvery(actions.ASYNC_CREATE_COURSE, addCourse);
    yield takeEvery(actions.ASYNC_DELETE_COURSE, removeCourse);
    yield takeEvery(actions.ASYNC_FETCH_TYPE_TESTS, fecthTypeTests);
    yield takeEvery(actions.ASYNC_FETCH_TESTS_BY_TYPE, fetchTestsByType);
    yield takeEvery(actions.ASYNC_FETCH_TESTS_BY_COURSE, fetchTestByCourse);
    yield takeEvery(
        actions.ASYNC_FETCH_COURSE_TEMPLATE_TESTS,
        asyncFetchCourseTemplateTests,
    );
    yield takeEvery(actions.ASYNC_SET_SELECT_TESTS_CREATE_COURSE, fetchCoursesCreateTestsTypes);
}


// WEBPACK FOOTER //
// ./src/components/courses/courses.saga.js